import React, { useContext, useEffect, useState } from "react";
import { Breadcrumb, Alert } from '@boozallen-uip/uswds-react-core';
import { useLocation } from 'react-router-dom';
import {
  ACCESS_DENIED,
  ACCESS_WAITING,
  ACCESS_NO_LOGIN,
  HOME_URL,
  VENDOR_OVERVIEW_URL,
  BASE_TITLE
} from "../../utlities/core.constants";

// import { VendorContext } from "./VendorContext";
import "./VendorOverview.page.scss";
import { UserContext } from "../UserContext";
import AccessStatus from "../../components/AccessStatus.component";
import { SectionContainer, } from "../shared.styled";
import VendorDetail from "./VendorDetail.component";
import PageHeader from "../../components/PageHeader/PageHeader.component";

export default function VendorOverview() {
  const { hasPendingRequestAccess, checkEntityAccessLevel, userEntity, user, isLoggedIn } = useContext(UserContext);
  const location = useLocation();
  const [successMessage, setSuccessMessage] = useState(null);

  document.title = `${BASE_TITLE} - Vendor Overview`;

  useEffect(() => {
    // Check for success message from navigation state
    if (location.state?.success && location.state?.message) {
      setSuccessMessage(location.state.message);

      // Clear the location state to prevent showing banner on refresh
      window.history.replaceState({}, document.title);

      // Auto-dismiss after 5 seconds
      const timer = setTimeout(() => {
        setSuccessMessage(null);
      }, 5000);

      return () => clearTimeout(timer);
    }

    return undefined;
  }, [location]);

  if (!isLoggedIn()) {
    return (
      <AccessStatus access={ACCESS_NO_LOGIN} />
    )
  }

  if (!checkEntityAccessLevel()) {
    return (
      <AccessStatus access={ACCESS_DENIED} />
    )
  }

  if (hasPendingRequestAccess) {
    return (
      <AccessStatus access={ACCESS_WAITING} />
    )
  }

  if (!userEntity || !user) {
    return null;
  }

  return (<div>
    <PageHeader imageUrl="/page-banners/account_hero_2x.webp" backgroundSize='2800px 391px' className='2xl:!bg-cover'>
      My Product Listings
    </PageHeader>
    <SectionContainer className='pt-4'>
      {successMessage && (
        <div className="mb-4" style={{ textAlign: 'left' }}>
          <Alert type="success" heading="Success" dismissible onDismiss={() => setSuccessMessage(null)}>
            {successMessage}
          </Alert>
        </div>
      )}
      <div>
        <Breadcrumb links={[{ "href": HOME_URL, "text": "Home" }, { "href": VENDOR_OVERVIEW_URL, "text": `${userEntity?.entity?.name} Overview Page` }]} />
      </div>
      <VendorDetail entity={userEntity.entity} primaryPoc={userEntity.primaryPoc} myListings />
    </SectionContainer>
  </div>
  );
}
